$(document).ready(function(){
	if($('#effectifyLocator').length) {
		var $html = $('#effectifyLocator').html();
		$('.effictifyLocator').append($html);
		$('#storeSearchInput.search-input').attr('placeholder', 'Search your location');
		// setTimeout(function(){
		// 	$('#googleMapIcon + div').remove();
		// }, 500);
	}
});

$(document).on('click', '.store-locator-open', function(){
	var $locator = $('.store-locator-main'),
	$offset = $locator.offset().top,
	$input = $('#storeSearchInput');
	$('html, body').animate({
		'scrollTop': $offset
	});
	$input.focus();
});

$(document).on('click', '.collection-tab-trigger', function(){
	var $this   = $(this),
			$target = $($this.data('target')),
			$parent = $this.closest('.featured-collection-tabs');

	$parent.find('.active-tab').removeClass('active-tab');
	$parent.find('.collection-tabs-item').hide();

	$this.addClass('active-tab');
	$target.show();
	var sliderEl = $target.find('.css-slider')[0];

	if (sliderEl) {
		sliderEl.destroySlider();
		sliderEl.initSlider();
	}
});


$(document).on('mouseover', '.custom-blog-item', function(){
	var $this = $(this);
	$('.active-blog').removeClass('active-blog');
	$this.addClass('active-blog');
	$('.highlighted-blog .custom-blog-image').html($this.data('content'));
	console.log($this.data('content'));
	$('.highlighted-blog h3 span').html($this.find('.custom-blog-meta h4').html());
});

$(document).on('change', 'quick-buy .product-variant__container--select', function(){
	var $this = $(this),
	$parent = $this.closest('quick-buy');
	$parent.find('form').removeClass('unavailable-variant');
	$parent.find('input[name="id"]').val($this.val());
	$parent.find('.add-to-cart').removeClass('disabled').find('.button__text').text('Add to cart');
});